import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const badgeVariants = cva(
  'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-hidden focus:ring-2 focus:ring-mint focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'bg-surface2 text-text border border-border',
        success: 'bg-successBg text-mint border border-mintBorder',
        warning: 'bg-warningBg text-amber border border-amber/30',
        destructive: 'bg-danger/20 text-danger border border-danger/30',
        secondary: 'bg-surface2 text-textMuted border border-border',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)

export interface BadgeProps
  extends React.ComponentPropsWithoutRef<'div'>, VariantProps<typeof badgeVariants> {}

const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(
  ({ className, variant, ...props }, ref) => {
    return <div ref={ref} className={cn(badgeVariants({ variant }), className)} {...props} />
  }
)
Badge.displayName = 'Badge'

export { Badge, badgeVariants }
